import { createSlice } from '@reduxjs/toolkit'
import { InteractionStatus, PublicClientApplication } from '@azure/msal-browser'

import { msalConfig, tokenRequest } from "./authConfig";

export const getToken = async (inProgress /* InteractionStatus */) => {
    const cfg = {
      auth: msalConfig.auth,
    }
  
    const pca = new PublicClientApplication(cfg)
    const accounts = pca.getAllAccounts()

    // Get an access token
    const request = {
        ...tokenRequest,
        account: accounts[0],
    };

    var accessToken = '';

    await pca.acquireTokenSilent(request)
        .then((response) => {
            accessToken = response.accessToken;
        })
        .catch((e) => {
            // Ensure we don't interfere with an ongoing MSAL interactive request
            if (inProgress === InteractionStatus.None) {
                pca.acquireTokenRedirect(request).then((response) => {
                    accessToken = response.accessToken;
                });
            }
        });
  
    return accessToken;
}

const initialState = { inProgress: "none" }

export const apiAuthSlice = createSlice({
  name: "apiAuth",
  initialState,
  reducers: {
      setMsalProgress(state, inProgress) {
        state.inProgress = inProgress.payload
      },
  },
})
